<template>
    <div class="component video-modal" :class="{ 'is-visible': isModalVisible, 'is-hidden': !isVideoModalOpen }">
        <div class="modal-wrapper">
            <div class="wrapper-medium">
                <div class="modal">
                    <div class="wrapper-video" :class="{ 'is-ready': isPlayerReady }">
                        <vue-vimeo-player
                            v-if="this.activeVideoId && this.isVideoModalOpen"
                            class="vimeo-container"
                            ref="player"
                            @ready="onReady"
                            :video-id="activeVideoId"
                            :options="{ dnt: true, responsive: true }"
                        />
                    </div>
                </div>
            </div>
        </div>
        <button-icon icon="close" @click.native="closeOverlay()" />
        <div class="modal-background"></div>
    </div>
</template>

<script>
    import { vueVimeoPlayer } from 'vue-vimeo-player';
    import ButtonIcon from './patterns/buttons/ButtonIcon';

    export default {
        name: 'VideoModal',
        components: {
            vueVimeoPlayer,
            ButtonIcon,
        },
        data() {
            return {
                isPlayerReady: false,
                isModalVisible: false,
            };
        },
        computed: {
            isVideoModalOpen() {
                return this.$store.getters.isVideoModalOpen;
            },
            activeVideoId() {
                return this.$store.getters.activeVideoId;
            },
            cookieSettings() {
                return this.$store.getters.cookieSettings;
            },
        },
        watch: {
            isVideoModalOpen(newValue, oldValue) {
                if (newValue) {
                    this.isModalVisible = true;
                }

                if (this.$refs.player) {
                    this.$refs.player.update(this.activeVideoId);
                }
            },
        },
        methods: {
            onReady() {
                // ggf. loader davor einblenden
                this.isPlayerReady = true;

                // ggf. später auslagern
                function iOS() {
                    return (
                        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
                            navigator.platform
                        ) ||
                        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
                    );
                }

                if (this.isVideoModalOpen && !iOS()) {
                    this.$refs.player.play();
                }
            },
            closeOverlay() {
                this.$refs.player.pause();
                this.isPlayerReady = false;
                this.isModalVisible = false;

                // use proper css transition event listener later
                setTimeout(() => {
                    this.$store.dispatch('toggleVideoModal');
                }, 500);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .video-modal {
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;

        [class^='wrapper'] {
            @media (max-width: breakpoint('medium')) {
                width: 100%;
                max-width: none;
            }
        }

        .modal-wrapper {
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: transform 0.3s, opacity 0.3s;
            z-index: 1;

            @media (max-width: breakpoint('medium')) {
                width: calc(100% - 50px);
            }

            @media (max-width: breakpoint('small')) {
                width: calc(100% - 30px);
            }
        }

        .modal-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.75);
            transition: opacity 0.5s;
            opacity: 0;
        }

        .modal {
            position: relative;
            @include flex($justify-content: space-between, $align-items: center);

            @media (max-width: breakpoint('medium')) {
                display: block;
                width: 100%;
                max-width: none;
            }
        }

        .wrapper-video {
            width: 100%;
            position: relative;
            padding-top: calc(100% / (16 / 9));
            opacity: 0;
            transition: opacity 0.5s, transform 0.5s;
            transform: translateY(30px);
        }

        .vimeo-container {
            position: absolute;
            width: 100% !important;
            top: 0;
            left: 0;
        }

        .btn {
            position: absolute;
            right: 30px;
            top: 30px;
            z-index: 1;
            opacity: 0;
            transition: opacity 0.3s, transform 0.3s;

            @media (max-width: breakpoint('small')) {
                right: 15px;
                top: 15px;
            }
        }

        &.is-hidden {
            opacity: 0;
            pointer-events: none;
        }

        &.is-visible {
            opacity: 1;
            pointer-events: all;

            .modal-background,
            .btn {
                opacity: 1;
            }

            .wrapper-video.is-ready {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @media (max-width: breakpoint('medium')) {
            width: 100%;
            transform: translate(0%, 100%);
            left: 0;
            bottom: 0;

            &.is-visible {
                transform: translate(0%, 0%);
            }
        }

        .wrapper-medium {
            @media (min-width: breakpoint('large')) {
                width: 1200px;
            }
        }
    }
</style>
